// src/app/services/app-insights.service.ts
import { Injectable } from '@angular/core';
import { ApplicationInsights, IConfiguration } from '@microsoft/applicationinsights-web';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AppInsightsService {
  // private router = inject(Router);

  private appInsights: ApplicationInsights;

  constructor() {

    // Configuração de inicialização do Application Insights
    const config: IConfiguration = {
      connectionString: environment.appInsights
    };

    this.appInsights = new ApplicationInsights({ config });
    this.appInsights.loadAppInsights();

    // Flow de rastreamento de Page Views via Router do Angular
    // this.router.events
    //   .pipe(
    //     filter(
    //       (evt: RouterEvent): evt is NavigationEnd => evt instanceof NavigationEnd
    //     )
    //   )
    //   .subscribe((evt: NavigationEnd) => {
    //     this.trackPageView(evt.urlAfterRedirects);
    //   });
  }

  /** Rastreia uma visualização de página no Application Insights */
  public trackPageView(url?: string, name?: string): void {
    this.appInsights.trackPageView({
      name: name || url,      // nome descritivo da página
      uri: url               // rota visitada
    });
  }

  /** Rastreia um evento customizado com propriedades (opcional) */
  public trackEvent(name: string, properties?: { [key: string]: any }): void {
    this.appInsights.trackEvent({ name }, properties);
  }

  /** Rastreia uma exceção manualmente */
  public trackException(error: Error, severityLevel?: number): void {
    this.appInsights.trackException({ exception: error, severityLevel });
  }

  /** Rastreia métricas customizadas */
  public trackMetric(name: string, average: number, properties?: { [key: string]: any }): void {
    this.appInsights.trackMetric({ name, average }, properties);
  }

  public trackDependency(
    method: string,
    url: string,
    success: boolean,
    duration: number,
    resultCode: number,
    name?: string
  ): void {
    this.appInsights.trackDependencyData({
      id: this.generateGuid(),
      name: name || `${method} ${url}`,
      duration,
      success,
      responseCode: resultCode,
      data: url,
      target: method
    });
  }

  private generateGuid(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
}
